<div class="te-col-center">
    <mat-card class="te-col-center te-panel" style="width: 800px;" [ngStyle]="loggingIn && {'background-color': 'rgba(233,131,0,0.1)'}">
        <mat-progress-bar *ngIf="loggingIn" mode="indeterminate"></mat-progress-bar>
        <h2 class="te-text" style="text-align: center; margin: 20px;">{{'SignIn'|translate}}</h2>
        <div *ngIf="errorMessage" class="te-form-600 te-alert-danger" style="margin-bottom: 20px;" [@dropIn]><span [innerHTML]="errorMessage | translate:translateValue"></span></div>
        <div *ngIf="successMessage" class="te-form-600 te-alert-info" style="margin-bottom: 20px;" [@dropIn]><span [innerHTML]="successMessage | translate"></span></div>

        <div *ngIf="isAppIDReqSucess">
            <button mat-raised-button class="te-button-blue" (click)="close()">
                {{'CrossBtnTxt'|translate}}
            </button>
        </div>


        <div *ngIf="showCaptchaForExternalLogin" class="te-form-350">

            <mat-form-field  appearance="fill" class="te-form-350" *ngIf="!isAppIDReqSucess">
                <mat-label style="font-size: 75% !important;" >{{'UserIDorEmail'|translate}}</mat-label>
                <input matInput
                       name="userID"
                       [(ngModel)]="userId"
                       type="text"
                       [readonly]="loggingIn || (signInOption === 'external_email' && loadingEmailSentStatus)|| (signInOption === 'app_id' && loadingAppIDUserData)||(signInOption === 'questions' && loadingQuestions) || isCaptchaSuccessful"
                       autocomplete="username"
                       spellcheck="false"
                       (blur)="userChanged()"
                       
                      (ngModelChange)="onUserIdChange($event)"
                       required [formControl]="username" />
                <mat-hint>{{'UserIDorEmail'|translate}}</mat-hint>
                <mat-icon matSuffix>account_circle</mat-icon>
                <mat-error style="font-size: 75% !important;">{{'USER-IDOREMAIL-REQ'|translate}}</mat-error>
            </mat-form-field>
            <br />
            <br />
            <div id="captchaHolderDiv" style="display:block;">
                <div id="captchaDiv"></div>
            </div>
            <div class="te-form-350 te-row-end" style="margin: 20px 0;">
                <button mat-raised-button class="te-button-blue"
                        [disabled]="!isCaptchaSuccessful || !userId || loggingIn" (click)="next()">
                    {{'BtnNext'|translate}}
                </button>
            </div>
        </div>


        <!--<div *ngIf="!isAppIDReqSucess">-->
        <div *ngIf="!showCaptchaForExternalLogin" class="te-form-350">
            <mat-form-field style="flex-grow: 1;" appearance="fill" class="te-form-350" *ngIf="!isAppIDReqSucess">
                <mat-label style="font-size: 75% !important;">{{'UserIDorEmail'|translate}}</mat-label>
                <input matInput
                       name="userID"
                       [(ngModel)]="userId"
                       type="text"
                       [readonly]="loggingIn || (signInOption === 'external_email' && loadingEmailSentStatus)|| (signInOption === 'app_id' && loadingAppIDUserData)||(signInOption === 'questions' && loadingQuestions) || isCaptchaSuccessful"
                       autocomplete="username"
                       spellcheck="false"
                       (blur)="userChanged()"
                       required [formControl]="username" />
                <mat-hint>{{'UserIDorEmail'|translate}}</mat-hint>
                <mat-icon matSuffix>account_circle</mat-icon>
                <mat-error style="font-size: 75% !important;">{{'USER-IDOREMAIL-REQ'|translate}}</mat-error>
            </mat-form-field>



            <mat-form-field appearance="fill" class="te-form-350" *ngIf="!isAppIDReqSucess">
                <mat-label>{{'SelectSignInOption'|translate}}</mat-label>
                <mat-select [(ngModel)]="signInOption" (selectionChange)="optionChanged()"
                            [disabled]="!userId || loggingIn || (signInOption === 'external_email' && loadingEmailSentStatus) || (signInOption === 'app_id' && loadingAppIDUserData) ||(signInOption === 'questions' && loadingQuestions)">

                    <!-- <mat-option>{{'SelectSignInOption'|translate}}</mat-option> -->
                    <mat-option *ngFor="let option of login.loginOptions" [value]="option.name">
                        {{ option.desc | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>



            <mat-form-field appearance="fill" *ngIf="signInOption === 'password'" class="te-form-350">
                <mat-label>{{'Password'|translate}}</mat-label>
                <input matInput name="password" [formControl]="password" [type]="hidePassword ? 'password' : 'text'" [readonly]="loggingIn"
                       autocomplete="one-time-code" (keyup.enter)="submitLogin()" spellcheck="false" />
                <mat-icon matSuffix style="cursor: pointer;" (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <div class="te-col-center" style="width: 100%;" *ngIf="signInOption === 'questions' && login.securityQuestions">
                <span class="te-form-350">{{ login.securityQuestions[0].securityQuestion }}</span>
                <mat-form-field appearance="fill" class="te-form-350">
                    <mat-label>{{'Answer'|translate}}</mat-label>
                    <input matInput name="securityQuestion1" [formControl]="question1" [type]="hideQuestion1 ? 'password' : 'text'" [readonly]="loggingIn"
                           autocomplete="one-time-code" (keyup.enter)="questionTwo.focus()" spellcheck="false" (keyup)="checkMinLength()" />
                    <mat-icon matSuffix style="cursor: pointer;" (click)="hideQuestion1 = !hideQuestion1">{{hideQuestion1 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
                <span class="te-form-350">{{ login.securityQuestions[1].securityQuestion }}</span>
                <mat-form-field appearance="fill" class="te-form-350">
                    <mat-label>{{'Answer'|translate}}</mat-label>
                    <input #questionTwo matInput name="securityQuestion2" [formControl]="question2" [type]="hideQuestion2 ? 'password' : 'text'" [readonly]="loggingIn"
                           autocomplete="one-time-code" (keyup.enter)="submitLogin()" spellcheck="false" (keyup)="checkMinLength()" />
                    <mat-icon matSuffix style="cursor: pointer;" (click)="hideQuestion2 = !hideQuestion2">{{hideQuestion2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
            </div>

            <div class="te-col-center" *ngIf="(signInOption === 'questions' && !login.securityQuestions && loadingQuestions)||(signInOption === 'app_id' && loadingAppIDUserData)||(signInOption === 'external_email' && loadingEmailSentStatus)">
                <mat-spinner mode="indeterminate"></mat-spinner>
            </div>

            <div class="te-col-center" style="width: 100%;" *ngIf="(signInOption === 'external_email') && (emailSent) && (!loadingEmailSentStatus)">
                <span class="te-form-350" style="text-align: left; font-size: 13px; font-weight: bold; font-style: italic;">
                    <!--Please provide the Identification Code sent to your External Email Address from SRM_NoReply@te.com:-->
                    <span [innerHTML]="'ExtTxtOTP' | translate:translateValue"></span>
                </span>
                <mat-form-field appearance="fill" class="te-form-350">
                    <mat-label>{{'ExtLblOTP'|translate}}</mat-label>
                    <input matInput name="otp" [formControl]="emailPasscode" required
                           [type]="hideEmailPasscode ? 'password' : 'text'" autocomplete="one-time-code" (keyup.enter)="submitLogin()" [readonly]="loggingIn"
                           spellcheck="false" />
                    <mat-icon matSuffix style="cursor: pointer;" (click)="hideEmailPasscode = !hideEmailPasscode">{{hideEmailPasscode ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
                <span class="te-form-350" style="text-align: left; font-size: 13px;">

                    {{'ExtTxtOTP1'|translate}}&nbsp;<!--Check whether an email from <b>SRM_NoReply@te.com</b> ended up in your "spam" or "junk" folders.-->
                    <span [innerHTML]="'ExtTxtOTP5' | translate:translateValue"></span>
                </span>

                <span class="te-form-350" style="text-align: center;">
                    <button mat-button (click)="sendNewEmail()" [disabled]="!userId || loggingIn || loadingEmailSentStatus || resendDisabled" [style.color]="(!userId || loggingIn || loadingEmailSentStatus || resendDisabled) ? 'gray' : '#3DB7E4'">{{'ExtTxtOTP2'|translate}}</button>
                </span>
                <div class="te-form-350 te-row-end te-vert-spacer" style="margin: 20px 0;">
                    <button mat-raised-button class="te-button-blue" (click)="submitLogin()" [disabled]="!userId || loggingIn || emailPasscode.invalid">{{ 'BtnSubmit' | translate}}</button>
                    <button mat-raised-button class="te-button-gray te-left-spacer" (click)="cancel()" [disabled]="!userId || loggingIn || loadingEmailSentStatus">
                        {{'BtnCancel'|translate}}
                    </button>
                </div>
            </div>

            <div *ngIf="signInOption === 'app_id'" class="te-form-350">

                <div *ngIf="canRequestAppId">

                    <div class="te-col-center">
                        <div class="te-row-full">

                        </div>
                        <div class="te-row-full">
                            <div class="te-col-start">
                                <!--<b>Requestor:</b>-->
                                <b>{{'RequestingUser' | translate}}</b>
                            </div>
                            <div class="te-col-start">
                                {{ login.appIdRequestorData.requestorName }}
                            </div>
                        </div>
                        <div class="te-row-full">
                            <div class="te-col-start">
                                <!--<b>Manager:</b>-->
                                <b>{{'Manager' | translate}}</b>
                            </div>
                            <div class="te-col-start">
                                {{ login.appIdRequestorData.managerName }}
                            </div>
                        </div>

                        <br />
                        <div class="te-row-full">
                            <div>{{'ReqAppIDMsg' | translate}}</div>
                        </div>
                    </div>

                    <div class="te-form-350 te-row-end te-vert-spacer" style="margin: 20px 0;">
                        <button mat-raised-button class="te-button-blue" (click)="requestAppID()" [disabled]="!userId || loggingIn || loadingAppIDUserData">{{'BtnSubmit' | translate}}</button>
                        <button mat-raised-button class="te-button-gray te-left-spacer" (click)="cancel()" [disabled]="!userId || loggingIn || loadingAppIDUserData">{{'BtnCancel' | translate}}</button>
                    </div>
                </div>
            </div>

            <mat-form-field appearance="fill" *ngIf="signInOption === 'adfs'" class="te-form-350">
            </mat-form-field>

            <div *ngIf="(signInOption !== 'app_id') && (signInOption !== 'external_email')" class="te-form-350 te-row-end" style="margin: 20px 0;">
                <button mat-raised-button class="te-button-blue" (click)="submitLogin()"
                        [disabled]="!userId || loggingIn || (password.invalid &&
                                    (question1.invalid && question2.invalid)) || IsSignInvalid">
                    {{ btnDynamic | translate}}
                </button>

                <button mat-raised-button class="te-button-gray te-left-spacer" (click)="cancel()"
                        [disabled]="!userId || loggingIn">
                    {{'BtnCancel'|translate}}
                </button>
            </div>

        </div>
    </mat-card>
</div>
